/*
 * The site's navigation — the first it has had.
 *
 * ⚠️ Until now every rebuilt page was reachable only from links wedged into the **legal
 * footer**, because `/` is still the previous implementation's homepage and its header carries
 * no navigation at all. That was the single largest gap in the rebuild: four finished surfaces
 * that a visitor had no way to discover.
 *
 * Three items, and the restraint is the point. `Wie wir arbeiten`, `Impressum` and
 * `Datenschutz` stay in the footer, where a reader looks for them and where they do not compete
 * with the three things this site is actually for.
 *
 * ☠️ Every entry must point at a **rebuild** route. Linking to `/categories/:category` or
 * `/search` would put the previous implementation's pages — which read the previous API — into
 * the primary navigation, and those pages break on any host that runs only the rebuild's
 * backend. `Themen` joins this list when `/thema/:slug` exists, not before.
 */

import { NavLink } from 'react-router';
import './nav.css';

// ⚠️ `end` on the root, or `NavLink` marks "Diese Woche" current on **every** page: without it
// `to="/"` matches any path that starts with a slash, which is all of them.
const ITEMS: { to: string; label: string; end?: boolean }[] = [
    { to: '/', label: 'Diese Woche', end: true },
    // ⚠️ Not `end`: `/rueckblick/2026-07-08` must also mark this item current, or browsing
    // the archive silently un-highlights the section the reader is in.
    { to: '/rueckblick', label: 'Rückblick' },
    { to: '/gesetze', label: 'Gesetzentwürfe' },
    { to: '/themen', label: 'Themen' },
    { to: '/parteien', label: 'Fraktionen' },
    { to: '/laender', label: 'Länder' },
];

export default function Nav() {
    return (
        <nav className="dq-nav" aria-label="Hauptnavigation">
            <ul>
                {ITEMS.map((item) => (
                    <li key={item.to}>
                        {/* `NavLink` sets aria-current="page" itself, which is what a screen
                            reader announces — the underline is only its visual echo. */}
                        <NavLink
                            to={item.to}
                            end={item.end}
                            className={({ isActive }) => (isActive ? 'is-current' : undefined)}
                        >
                            {item.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
